// removed by extract-text-webpack-plugin
module.exports = {"is-focused":"_2YwrA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/components/SelectInput/SelectInput.scss
// module id = 1790
// module chunks = 0